import { render, staticRenderFns } from "./Synopsis.vue?vue&type=template&id=c872fbc8&"
import script from "./Synopsis.vue?vue&type=script&lang=js&"
export * from "./Synopsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports